<template>
  <div class="esport-page-container">
    <template v-if="!curNewsId">
      <div class="left-box">
        <div class="tab-switch-list">
          <div
            class="tab-item"
            :class="{ active: activeTabKey == tab.key }"
            v-for="tab in tabList"
            :key="tab.key"
            @click="activeTabKey = tab.key"
          >
            <span>{{ tab.name }}</span>
          </div>
        </div>
        <div class="tab-container">
          <div class="news-list" v-scroll-down-to-get-data="getNextPageNews">
            <div
              class="news-item"
              v-for="item of (newsTab[activeTabKey] || { list: [] }).list"
              :key="item._id"
              @click="openNewsDetail(item._id)"
            >
              <div
                class="news-thumbnail"
                :style="{
                  backgroundImage: item.thumbnail
                    ? `url(${item.thumbnail})`
                    : '',
                }"
              ></div>
              <div class="news-info">
                <div class="news-title">{{ item.title }}</div>
                <div class="news-summary">{{ getNewsSummary(item) }}</div>
                <div class="news-update">
                  {{ item.updatedAt | formatDate("YYYY/MM/DD HH:mm") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-splint-box"></div>
      </div>
      <div class="right-box">
        <div class="news-banner-box">
          <div class="news-banner-border">
            <div
              class="inner-box"
              v-if="newsBannerList && newsBannerList.length"
            >
              <div
                class="cur-banner"
                :style="{
                  backgroundImage:
                    newsBannerList[curBannerIndex] &&
                    newsBannerList[curBannerIndex].image
                      ? `url(${newsBannerList[curBannerIndex].image})`
                      : '',
                }"
                @click="openNewsDetail(newsBannerList[curBannerIndex].newsId)"
              >
                <div class="banner-title">
                  {{ newsBannerList[curBannerIndex].title }}
                </div>
              </div>
              <div class="banner-list">
                <div
                  class="banner-item"
                  :class="{ active: index == curBannerIndex }"
                  v-for="(banner, index) of newsBannerList"
                  :key="index"
                  :style="{
                    backgroundImage: banner.image ? `url(${banner.image})` : '',
                  }"
                  @click="curBannerIndex = index"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <newsDetail
      @back="back"
      v-if="curNewsId"
      class="news-detail"
      :newsId="curNewsId"
    />
  </div>
</template>

<script>
import { getDict, getPageDictInit, invokeNative, axios, bus } from "@/common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import AutoTitle from "@/components/autoTitle";
import newsDetail from "./newsDetail";

const getPageDict = getPageDictInit("eSport");

export default {
  name: "eSportNews",
  // mixins: [getPageLevelMixin],
  components: {
    AutoTitle,
    newsDetail,
  },
  props: {},
  data() {
    return {
      tabList: [
        {
          name: getPageDict(18) /* "赛事新闻" */,
          key: "matchNews",
        },
        {
          name: getPageDict(19) /* "战队新闻" */,
          key: "clubNews",
        },
        {
          name: getPageDict(20) /* "版本更新" */,
          key: "versionNews",
        },
        {
          name: getPageDict(21) /* "豆知識" */,
          key: "knowledge",
        },
      ],
      activeTabKey: "matchNews",
      curNewsId: "",
      curBannerIndex: 0,
      nextSwitchBannerTime: 0,
      switchBannerWait: 5,
    };
  },
  computed: {
    ...mapGetters(["nowTs"]),
    ...mapState({
      newsTab: (state) => state.eSportPage.newsTab,
      newsBannerList: (state) => state.eSportPage.newsBannerList,
    }),
  },
  watch: {
    curBannerIndex() {
      this.nextSwitchBannerTime = this.nowTs + this.switchBannerWait * 1000;
    },
    nowTs() {
      if (
        this.nowTs > this.nextSwitchBannerTime &&
        this.nextSwitchBannerTime > 10
      ) {
        this.autoSwitchBanner();
      }
    },
  },
  methods: {
    getDict,
    getPageDict,
    getNextPageNews() {
      store.dispatch("eSportPage/getNextPageTabNews", {
        tabKey: this.activeTabKey,
      });
    },
    getNewsSummary(newsObj) {
      let part = newsObj.partList.find((p) => p.valueType == "text");
      let text;
      if (part) {
        text = part.value.split("\n").find((p) => !!p.trim());
      }
      return text || newsObj.title;
    },
    autoSwitchBanner() {
      this.curBannerIndex =
        (this.curBannerIndex + 1) % this.newsBannerList.length;
    },
    openNewsDetail(newsId) {
      if (newsId) {
        this.curNewsId = newsId;
      }
    },
    back() {
      this.curNewsId = "";
    },
  },
  mounted() {},
  created() {
    store.dispatch("eSportPage/getNewsPageIndexDataWhileNeed");
    this.nextSwitchBannerTime = this.nowTs + this.switchBannerWait * 1000;
    bus.$once("showESportNewsId", (id) => {
      this.openNewsDetail(id);
    });
  },
};
</script>

  <style lang="scss" scoped>
/* 定义$page-nav-height */
@import "../../comps/nav/index.scss";
.esport-page-container {
  $page-container-margin-top: 0.12rem;
  height: 0;
  flex: 1;
  margin-top: $page-container-margin-top;
  display: flex;

  .box-title {
    $height: 0.61rem;
    $margin-bottom: -0.1rem;
    width: 100%;
    height: $height;
    margin-bottom: $margin-bottom;
    color: #292829;
    line-height: $height;
    font-size: 0.22rem;
    font-weight: 600;
    text-align: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .left-box {
    width: 8.24rem;
    display: flex;
    flex-direction: column;
    // border: 1px solid #f00;

    .tab-switch-list {
      display: flex;
      .tab-item {
        flex: 1;
        // width: 2.01rem;
        height: 0.7rem;
        flex-shrink: 0;
        font-size: 0.24rem;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        // background: url(./imgs/nav-item.png);
        // background-image: url(../../imgs/tab-nav.png);
        background-image: url(../../imgs/tab-switch-btn-bg.png);
        background-size: 100% 100%;
        &:not(:first-child) {
          border-left: 0.01rem solid #ffeb78;
        }

        span {
          background-image: -webkit-linear-gradient(bottom, #f39b25, #a76002);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        &.active {
          // background-image: url(./imgs/nav-item-active.png);
          // background-image: url(../../imgs/tab-nav-active.png);
          background-image: url(../../imgs/tab-switch-btn-bg-active.png);
          span {
            background-color: #292829;
            background-image: none;
          }
        }
      }
    }
    .tab-container {
      flex: 1;
      height: 0;
      background-color: rgba(#fff, 0.3);
      display: flex;
      flex-direction: column;

      .news-list {
        height: 0;
        flex: 1;
        overflow-y: auto;
        padding: 0.2rem;
        .news-item {
          $height: 1.12rem;
          height: $height;
          display: flex;
          &:not(:first-child) {
            margin-top: 0.1rem;
          }
          .news-thumbnail {
            width: 1.98rem;
            height: $height;
            background-size: cover;
            background-position: center;
          }
          .news-info {
            width: 0;
            flex: 1;
            color: #292829;
            margin-left: 0.2rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .news-title {
              font-weight: 600;
              font-size: 0.2rem;

              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .news-summary {
              font-size: 0.16rem;
              // margin-top: 0.1rem;

              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .news-update {
              color: #c37d06;
              font-size: 0.14rem;
              margin-top: 0.15rem;
            }
          }
        }
      }
    }
  }

  .right-box {
    width: 0;
    flex: 1;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
    margin-top: -$page-nav-height - $page-container-margin-top;

    .news-banner-box {
      height: 100%;
      display: flex;
      flex-direction: column;
      .news-banner-border {
        height: 100%;
        display: flex;
        flex-direction: column;
        $border-radius: 0.04rem;
        border-radius: $border-radius;
        position: relative;
        padding: 0.1rem;
        background-color: rgba(#fff, 0.3);
        $border-weight: 0.02rem;
        $border-color: #fff;
        $color-start: 10%;
        $color-end: 30%;

        &::after,
        &::before {
          content: "";
          // z-index: 20;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          border-radius: $border-radius;
        }
        $linear-deg: 50;
        &::before {
          border-left: $border-weight solid $border-color;
          border-bottom: $border-weight solid $border-color;
          mask: linear-gradient(
            #{$linear-deg * 1deg},
            #000 #{$color-start},
            transparent #{$color-end}
          );
        }
        &::after {
          border-top: $border-weight solid $border-color;
          border-right: $border-weight solid $border-color;
          mask: linear-gradient(
            #{($linear-deg + 180) * 1deg},
            #000 #{$color-start},
            transparent #{$color-end}
          );
        }
      }
      .inner-box {
        width: 100%;
        flex: 1;
        position: relative;
        z-index: 5;
        display: flex;
        flex-direction: column;
        .cur-banner {
          height: 4.25rem;
          background-size: cover;
          background-position: center;
          display: flex;
          flex-direction: column-reverse;
          .banner-title {
            font-size: 0.18rem;
            color: #fff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0.1rem;
            text-shadow: 0rem 0rem 1px rgba(0, 0, 0, 1),
              0rem 0rem 1px rgba(0, 0, 0, 1), 0rem 0rem 1px rgba(0, 0, 0, 1);
          }
        }
        .banner-list {
          margin-top: 0.1rem;
          flex: 1;
          display: flex;
          .banner-item {
            width: 0;
            flex: 1;
            background-size: cover;
            background-position: center;
            border: 0.01rem solid #fff;
            &:not(:first-child) {
              margin-left: 0.1rem;
            }
            &.active {
              &::before {
                content: "";
                display: block;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                border: 0.02rem solid #ffc44f;
              }
            }
          }
        }
      }
    }
  }
}
.news-detail {
  width: 100%;
  height: 100%;
}
.bottom-splint-box {
  $margin-bottom: 0.08rem;
  width: 100%;
  height: $margin-bottom;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    flex: 1;
    height: 0.04rem;
    border-bottom: 0.01rem solid rgba(#fff, 0.4);
    margin-right: 0.04rem;
  }
  &::after {
    content: "";
    width: 0.34rem;
    height: 0.04rem;
    background-image: url(../../imgs/box-bottom-splint.png);
    background-size: 100% 100%;
  }
}
</style>
